<template>
  <v-autocomplete
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.projectId"
    item-text="nome"
    item-name="nome"
    item-value="projetoId"
    :items="projects"
    :label="label"
    placeholder="Projetos"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    multiple
    clearable
    :rules="rules"
    chips
    closable-chips
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.projectId.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.projectId.length - maxDisplay }} projetos)</span
      >
    </template>

    <template slot="no-data"> Nenhum Projeto retornado </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from "vuex";
import { projectAPI } from "./ProjectAPI";

export default {
  name: "ProjectByUfCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    filter: {
      type: Object,
      default: () => {
        ({ eixosIds: [] });
      },
    },

    label: {
      type: String,
      default: "",
    },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.load();
  },
  computed: {
    likesAll() {
      return this.filter.projectId.length === this.projects.length;
    },
    likesSome() {
      return this.filter.projectId.length > 0 && !this.projects;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    load() {
      projectAPI
        .getProjetoByUf(this.$store.state.uf)
        .then((resp) => {
          this.projects = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Projetos");
        });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.projectId = [];
          this.$emit("onChange", this.filter.projectId);
        } else {
          this.filter.projectId = this.projects.slice();
          this.$emit("onChange", this.filter.projectId);
        }
      });
    },
  },
  data() {
    return {
      maxDisplay: 2,
      projects: [],
    };
  },
};
</script>

<style scoped>
.tema-eixo-combo {
  padding: 0 0 20px;
}
</style>
